import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgentsMap.css';
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const AgentsMap = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [agentSports, setAgentSports] = useState([]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Baseball',
                image: '/basic/web/images/scout/scoutmap-11.jpg',
                url:'/agents/baseball',
            },
            {   
                id: "2", 
                name: 'Basketball',
                image: '/basic/web/images/scout/scoutmap-22.jpg',
                url:'/agents/basketball',
            },
            {   
                id: "3", 
                name: 'Cricket',
                image: '/basic/web/images/scout/scoutmap-33.jpg',
                url:'/agents/cricket',
            },
            {   
                id: "4", 
                name: 'Football',
                image: '/basic/web/images/scout/scoutmap-44.jpg',
                url:'/agents/football',
            },
            {   
                id: "5", 
                name: 'Hockey',
                image: '/basic/web/images/scout/scoutmap-55.jpg',
                url:'/agents/hockey',
            },
            {   
                id: "6", 
                name: 'Soccer',
                image: '/basic/web/images/scout/scoutmap-66.jpg',
                url:'/agents/soccer',
            },
            {   
                id: "7", 
                name: 'Rugby',
                image: '/basic/web/images/scout/scoutmap-77.jpg',
                url:'/agents/rugby',
            },
        ];
        setAgentSports(staticData);
    },[]);

    const firstHalf = agentSports.slice(0, 4); 
    const secondHalf = agentSports.slice(4); 

    const handleClick = (continent) => {
        navigate('/continents/'+continent+'/agents');
    };

    const handleUSClick = () => {
        navigate('/sports_agents_usmap');
    };

    const handleCanadaClick = () => {
        navigate('/sports_agent_canada_map');
    };

    return (
        <>
       {isLoading ? (
            <Loading />
        ) : (
            <div id="main" className="agentsmap-main">
                <Helmet><title>Find a Sports Agent near me</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <h1>Find A Sports Agent Near You</h1>
                    <p>
                        Sports Management Worldwide is proud to have Agent Advisors&nbsp;located all over the world. 
                        If you are an athlete looking for professional representation <b><a href="/lookingforagent.php">please request an agent here</a></b>.
                         An Agent Advisor will contact you to discuss your next step with Sports Management Worldwide Agency. 
                        In order to provide the best service possible, please give as much detail as you can!
                    </p>
                    <div style={{clear: "both"}}></div>
                    <div style={{margin: "auto", textAlign: "center"}}>
                        <div className="webmaparea">
                            <h2 className="rtecenter">
                                <span style={{lineHeight: "20.8px"}}>
                                    To view our rapidly expanding network of agents around the world,<br />
                                    click on a continent from the world map below.
                                </span>
                            </h2>
                            <p></p>                              
                            <img
                                src="/basic/web/images/agencyhome-map.jpg"
                                alt="World Map"
                                useMap="#Mapu"
                                style={{
                                    width: '100%',
                                    maxWidth: '800px',
                                    height: 'auto'
                                }}
                            />
                            <map id="Mapu" name="Mapu">
                                <area coords="11,32,104,124" href onClick={(e) => {e.preventDefault(); handleUSClick();}} shape="rect" /> 
                                <area coords="104,97,256,148" href onClick={(e) => {e.preventDefault(); handleUSClick();}} shape="rect" /> 
                                <area coords="105,13,365,98" href  onClick={(e) => {e.preventDefault(); handleCanadaClick();}} shape="rect" /> 
                                <area coords="105,148,241,188" href onClick={(e) => {e.preventDefault(); handleClick('1');}} shape="rect" /> 
                                <area coords="190,187,326,350" href onClick={(e) => {e.preventDefault(); handleClick('2');}} shape="rect" /> 
                                <area coords="368,32,541,119" href onClick={(e) => {e.preventDefault(); handleClick('3');}} shape="rect" /> 
                                <area coords="544,26,794,239" href onClick={(e) => {e.preventDefault(); handleClick('4');}} shape="rect" /> 
                                <area coords="911,330,1051,440" href onClick={(e) => {e.preventDefault(); handleClick('6');}} shape="rect" /> 
                                <area coords="655,239,774,334" href onClick={(e) => {e.preventDefault(); handleClick('6');}} shape="rect" /> 
                                <area coords="352,128,525,310" href onClick={(e) => {e.preventDefault(); handleClick('5');}} shape="rect" /> 
                                <area coords="488,120,544,178" href onClick={(e) => {e.preventDefault(); handleClick('4');}} shape="rect" />
                            </map>
                        </div>

                        <div className="mobile-map-heading">
                            <h1 style={{clear:"both"}}>Agents in All Over World</h1>
                        </div>
                        <div className="mobilemaparea">
                            <h1><a onClick={(e) => {e.preventDefault(); handleCanadaClick();}}>Agents in Canada</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleClick('1');}}>Agents in Mexico &amp; Central America</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleUSClick();}}>Agents in US</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleClick('2');}}>Agents in South America</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleClick('3');}}>Agents in Europe</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleClick('4');}}>Agents in Asia &amp; Middle East</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleClick('5');}}>Agents in Africa</a></h1>
                            <h1><a onClick={(e) => {e.preventDefault(); handleClick('6');}}>Agents in South Pacific</a></h1>
                        </div>
                    </div>
                    <p>
                        <a className="reddbtnn" href="/agents" style={{textAlign: "center"}}>
                            VIEW A LIST OF ALL OUR AGENTS
                        </a>
                    </p>
                    <p>&nbsp;</p>
                    <hr />
                    <h2 className="rtecenter">To find an agent by sport, click below:&nbsp;</h2>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                    <div className="imgboxxe">
                        {firstHalf.map((agentSport, index) => (
                            <span key={index}>
                                <a href={agentSport.url}><img src={agentSport.image} alt={agentSport.name} /></a>
                            </span>
                        ))}
                    </div>
                    <div className="imgboe">
                        {secondHalf.map((agentSport, index) => (
                            <span key={index}>
                                <a href={agentSport.url}><img src={agentSport.image} alt={agentSport.name} /></a>
                            </span>
                        ))}
                    </div>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                </div>
                <div className="right">
                    <AgencySidebar />
                    <SalespersonSidebar />
                </div>
            </div>
        )}
        </>
    );
};
export default AgentsMap;